import { Popover } from '../controls/Popover';
import { LoanArrangerBankLink } from './LoanArrangerBankLink';

export interface LoanCoArrangersPopoverProps {
    issuer: string;
    coArrangers: string[];
}

export function LoanCoArrangersPopover({ issuer, coArrangers }: LoanCoArrangersPopoverProps) {
    return (
        <Popover
            title="Co-Arrangers"
            label={<span className="name-tag text-ellipsis">{issuer}</span>}
            actionButton={
                <button className="pseudo-link">
                    View ({coArrangers.length})
                </button>
            }
        >
            <ul className="co-arrangers-list">
                {coArrangers.map(referenceName => (
                    <li key={referenceName} className="popover-item">
                        <LoanArrangerBankLink companyReferenceName={referenceName} />
                    </li>
                ))}
            </ul>
        </Popover>
    );
}
